export class AppBuildValues {
  buildVersion: string;
  buildTime: string;

  constructor(version = '', date = '') {
    this.buildVersion = version;
    this.buildTime = date;
  }
}
